var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLineWithPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 48,
    width: 48,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.5 17.75-2.1-2.1 4.15-4.15H15.8q-.4 1.6-1.55 2.75T11.5 15.8v16.4q1.95.5 3.225 2.1Q16 35.9 16 38q0 2.5-1.75 4.25T10 44q-2.5 0-4.25-1.75T4 38q0-2.1 1.275-3.7T8.5 32.2V15.8q-1.95-.5-3.225-2.1Q4 12.1 4 10q0-2.5 1.75-4.25T10 4q2.1 0 3.7 1.275T15.8 8.5h7.75L19.4 4.35l2.1-2.1L29.3 10ZM38 4q2.5 0 4.25 1.75T44 10q0 2.5-1.75 4.25T38 16q-2.5 0-4.25-1.75T32 10q0-2.5 1.75-4.25T38 4ZM10 41q1.3 0 2.15-.875Q13 39.25 13 38q0-1.3-.85-2.15Q11.3 35 10 35q-1.25 0-2.125.85T7 38q0 1.25.875 2.125T10 41Zm0-28q1.3 0 2.15-.875Q13 11.25 13 10q0-1.3-.85-2.15Q11.3 7 10 7q-1.25 0-2.125.85T7 10q0 1.25.875 2.125T10 13Zm28 0q1.3 0 2.15-.875Q41 11.25 41 10q0-1.3-.85-2.15Q39.3 7 38 7q-1.25 0-2.125.85T35 10q0 1.25.875 2.125T38 13ZM10 38Zm0-28Zm28 0Zm-6.55 14.05 2.15 2.1L23 36.7V41h4.25L37.9 30.35l2.1 2.1L28.5 44H20v-8.5Zm8.55 8.4-8.55-8.4 3.25-3.25q.85-.85 2.125-.85t2.125.9l4.2 4.25q.85.9.85 2.125t-.9 2.075Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineWithPencil);
export default __webpack_public_path__ + "static/media/line-with-pencil.bf91e0a247959a13e1317f2c1c0b0b5a.svg";
export { ForwardRef as ReactComponent };